import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router";
import { api, ApiError } from "@/shared/api";
import { s } from "@/shared/strings";
import { Button } from "@/shared/components/ui/button";
import { Input } from "@/shared/components/ui/input";
import { Label } from "@/shared/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/shared/components/ui/card";
import { Logo } from "@/shared/components/Logo";

// /redefinir-senha — sem token: pede e-mail e envia link; com ?t=: nova senha.
export function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("t");
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      if (token) {
        await api.resetPassword(token, password);
        nav("/host");
      } else {
        await api.forgot(email);
        setSent(true);
      }
    } catch (ex) {
      setErr(ex instanceof ApiError ? ex.message : "Erro inesperado.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="bg-bg flex min-h-dvh flex-col items-center justify-center px-6 py-10">
      <div className="w-full max-w-sm">
        <Link to="/" className="mb-8 flex justify-center">
          <Logo />
        </Link>
        <Card>
          <CardHeader>
            <CardTitle>{s.resetPassword}</CardTitle>
          </CardHeader>
          <CardContent>
            {sent ? (
              <p className="text-16 text-ok">{s.magicLinkSent}</p>
            ) : (
              <form onSubmit={submit} className="flex flex-col gap-4">
                {token ? (
                  <div className="flex flex-col gap-2">
                    <Label htmlFor="password">Nova senha (mín. 8)</Label>
                    <Input
                      id="password"
                      type="password"
                      required
                      minLength={8}
                      autoComplete="new-password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                ) : (
                  <div className="flex flex-col gap-2">
                    <Label htmlFor="email">{s.email}</Label>
                    <Input
                      id="email"
                      type="email"
                      required
                      autoComplete="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                )}
                {err && <p className="text-14 text-bad font-semibold">{err}</p>}
                <Button type="submit" disabled={busy} className="w-full">
                  {token ? s.resetPassword : s.send}
                </Button>
              </form>
            )}
          </CardContent>
        </Card>
        <p className="text-14 text-chalk-3 mt-6 text-center">
          <Link to="/entrar" className="text-amber-fg font-semibold hover:underline">
            {s.login}
          </Link>
        </p>
      </div>
    </main>
  );
}
